<div>
	<h1>
		<i [class]="currentNavTab?.icon"></i>
		
		{{currentNavTab?.label}}
	</h1>
</div>